function hasExplicitSchemeOrRootPath(value) {
  return /^(https?:)?\/\//i.test(value) || value.startsWith("/");
}

const PERSISTENCE_ASSET_PATH_PATTERN = /\/assets\/([^/?#]+)/i;

function escapeRegex(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function getPersistenceOrigin(persistenceApiUrl) {
  if (!persistenceApiUrl) return null;

  try {
    return new URL(persistenceApiUrl).origin;
  } catch {
    return null;
  }
}

export function isPersistenceUrl(url, { persistenceApiUrl, currentUrl } = {}) {
  if (typeof url !== "string") return false;

  const normalizedUrl = url.trim();
  const persistenceOrigin = getPersistenceOrigin(persistenceApiUrl);
  const fallbackCurrentUrl =
    currentUrl || (typeof window !== "undefined" && window.location ? window.location.href : "http://localhost");

  if (!normalizedUrl || !persistenceOrigin || !hasExplicitSchemeOrRootPath(normalizedUrl)) {
    return false;
  }

  try {
    return new URL(normalizedUrl, fallbackCurrentUrl).origin === persistenceOrigin;
  } catch {
    return false;
  }
}

export function extractPersistenceFileId(url, options = {}) {
  if (typeof url !== "string") return null;

  const normalizedUrl = url.trim();
  const persistenceOrigin = getPersistenceOrigin(options.persistenceApiUrl);

  if (!normalizedUrl || !persistenceOrigin) {
    return null;
  }

  const decodedUrl = decodeURIComponent(normalizedUrl);
  const absoluteAssetPattern = new RegExp(`${escapeRegex(persistenceOrigin)}/assets/([^/?#]+)`, "i");

  for (const candidate of [normalizedUrl, decodedUrl]) {
    const absoluteMatch = candidate.match(absoluteAssetPattern);
    if (absoluteMatch) {
      return absoluteMatch[1];
    }
  }

  if (!isPersistenceUrl(normalizedUrl, options)) {
    return null;
  }

  try {
    const fallbackCurrentUrl =
      options.currentUrl ||
      (typeof window !== "undefined" && window.location ? window.location.href : "http://localhost");
    const pathname = new URL(normalizedUrl, fallbackCurrentUrl).pathname;
    return pathname.match(PERSISTENCE_ASSET_PATH_PATTERN)?.[1] || null;
  } catch {
    return null;
  }
}
